import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=b35d227a&"
import script from "./campus.vue?vue&type=script&lang=js&"
export * from "./campus.vue?vue&type=script&lang=js&"
import style0 from "./campus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports